import { render } from "./ButtonShow.vue?vue&type=template&id=be38bd7e&scoped=true"
import script from "./ButtonShow.vue?vue&type=script&lang=js"
export * from "./ButtonShow.vue?vue&type=script&lang=js"

import "./ButtonShow.vue?vue&type=style&index=0&id=be38bd7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be38bd7e"]])

export default __exports__